// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from './utils/Vue';
import App from './App';
import router from './router';
import store from './store';

Vue.config.productionTip = false;
// window.console.log('环境配置', process.env.NODE_ENV);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});




// WEBPACK FOOTER //
// ./src/main.js